'use client';

interface Category {
  value: string;
  label: string;
  labelDe: string;
}

interface ProjectFilterProps {
  categories: Category[];
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
  currentLanguage: 'en' | 'de';
}

const ProjectFilter = ({ categories, selectedCategory, onCategoryChange, currentLanguage }: ProjectFilterProps) => {
  return (
    <div className="flex flex-wrap justify-center gap-4 animate-fade-in" style={{ animationDelay: '200ms' }}>
      {categories.map((category) => (
        <button
          key={category.value}
          onClick={() => onCategoryChange(category.value)}
          className={`px-6 py-3 rounded-lg font-inter font-semibold text-sm transition-all duration-fast ${
            selectedCategory === category.value
              ? 'bg-accent text-primary shadow-glow-cyan'
              : 'bg-secondary hover:bg-secondary/80 text-foreground-muted hover:text-foreground-light border border-border'
          }`}
          aria-pressed={selectedCategory === category.value}
        >
          {currentLanguage === 'en' ? category.label : category.labelDe}
        </button>
      ))}
    </div>
  );
};

export default ProjectFilter;